import Embed from "@pathwright/ui/src/components/embed/Embed"
import PropTypes from "prop-types"
import "./ContentMethodEmbedPreview.css"

const ContentMethodEmbedPreview = ({ code }) => (
  <div className="ContentMethod__EmbedPreview">
    {code ? <Embed code={code} executeScripts={true} /> : undefined}
  </div>
)

ContentMethodEmbedPreview.displayName = "ContentMethodEmbedPreview"
ContentMethodEmbedPreview.propTypes = { code: PropTypes.string }

export default ContentMethodEmbedPreview
